export enum CabinetRange {
  Standard = 'S',
  MIST = 'M',
  Premium = 'P',
}

export enum CabinetSupport {
  NoSupport = 'N',
  Feet = 'F',
  AdjustableFeet = 'A',
  WheelWhite = 'W',
  WheelBlack = 'B',
  ToHangScrew = 'S',
  ToHangHook = 'H',
}

export enum Position {
  Front = 'F',
  Right = 'R',
  Back = 'B',
  Left = 'L',
}

export enum PositionAngle {
  FrontLeft = 'FL',
  FrontRight = 'FR',
  BackLeft = 'BL',
  BackRight = 'BR',
}

export enum PositionLateral {
  Left = 'L',
  Right = 'R',
}

// export enum PositionLevel {
//   first = 0,
//   second = 1,
//   third = 2,
//   fourth = 3,
//   fifth = 4,
// }

export enum DoorHole {
  nothing = 0,
  button = 4,
  cup = 30,
  cupLarge = 38,
}

export enum DoorHandleType {
  Knop = 'C',
  Button = 'B',
  BigButton = 'H',
  Slat = 'S',
  GlassHole = 'G',
}

export enum PositionLargeDoor {
  Inside = 'I',
  Outside = 'E',
}

export enum CrossPieceType {
  /**
   * If we need a PD or DP, Kewlox use DD instead
   */
  UpperEmptyLowerPane = 'EP', // F2
  UpperEmptyLowerDoors = 'ED', // G2
  UpperPaneLowerPane = 'PP', // F1
  UpperDoorsLowerDoors = 'DD', // G1
}

export enum PlateType {
  DoorsDoors = 'DD',
  DoorsPane = 'DP',
  PanePane = 'PP',
}

export enum CornerType {
  Normal = 'N',
  Hook = 'H',
  Front = 'F', //The corner is drilled to fix to the wall without hook
}

export enum Material {
  Wood = 'W',
  Aluminium = 'A',
  White = 'B',
  Black = 'N',
}

export enum PaneMaterial {
  MDF = 'M',
  Frost = 'F',
  FrostOpaque = 'O',
  Glass = 'G',
  Mirror = 'I',
  Alu = 'A',
}

export enum DrawerHandleType {
  Knop = 'K',
  Button = 'B',
  Slat = 'S',
  Eco = 'E',
  EcoPlus = 'EP',
}

export enum ShelfComposition {
  Open = 'open',
  TwoDoors = '2-doors',
  FourDoors = '4-doors',
  Drawer = 'drawers',

  LargeTwoDoors = 'large-2-doors',
  LargeFourDoors = 'large-4-doors',
}

// (mm) the maximum height of corner
export const MIN_CORNER_HEIGHT = 37;
export const MAX_CORNER_HEIGHT = 5000;
export const MIN_SHELF_HEIGHT = 40;
export const MAX_SHELF_HEIGHT = 1600;

export const SABOT_HEIGHT = 20;
export const CORNER_HANG_CABINET_HEIGHT_SURPLUS = 30;

export const CROSS_PIECE_HEIGHT = 40;

export const GROUND_OFFSET = 1000;

export const DEFAULT_SHELF_HEIGHT = 370;

export const DRAWER_HEIGHT = [100, 135, 170, 200, 270, 370];

// TODO: Ask Kewlox the space left after adding new inter. shelf
export const MINIMUM_HEIGHT_SPACE_AFTER_ADDING_INTERMEDIATE_SHELF = 60;

export const BIG_SHELF_MINIMUM_HEIGHT = 800;
export const MINIMUM_WIDTH_FOR_TWO_DRAWER_HANDLES = 800;

export const MINIMUM_LARGE_DOORS_HEIGHT = 600;

export const ALUMINIUM_COLOR = 'DIBOND';
export const NATURAL_COLOR = 'BRUT';
export const WHITE_COLOR = 'W4006';
export const BLACK_COLOR = 'U4020';
export const BLUE_COLOR = 'U4017';
export const ECO_COLOR = 'BRUT-ECO';
export const ECO_PLUS_COLOR = 'ECO-PLUS';
export const WHITE_OPAQUE_COLOR = '1T41';
export const BLACK_OPAQUE_COLOR = '9221';

export const AQUA_COLOR = '7T1D';
export const POLAR_COLOR = '030';
export const INOX_COLOR = 'INOX';
export const GALVA_COLOR = 'GALVA';
export const GLASS_COLOR = 'V3';
export const MIRROR_COLOR = 'M3';

export const CREAM_COLOR = 'U4018';
export const BROWN_COLOR = 'BROWN';
export const GREEN_COLOR = '379044';

export const DEFAULT_MDF_COLOR = BLACK_COLOR;
export const DEFAULT_FROST_COLOR = POLAR_COLOR;

export const STANDARD_COLOR = WHITE_COLOR;

export const BATTEN_WIDTH = 19.2;
export const BATTEN_DEPTH = 19.2;

export const CROSS_PIECE_DEPTH_ONE_GROOVE = 21;
export const CROSS_PIECE_DEPTH_TWO_GROOVES = 31;

export const CROSS_PIECE_REINFORCEMENT_DEPTH_HEIGHT = 22;
export const CROSS_PIECE_REINFORCEMENT_DATA1_FOR_WEIGHT = 48;
export const CROSS_PIECE_REINFORCEMENT_DATA2_FOR_WEIGHT = 1.55;

export const CROSS_PIECE_WOODD_DENSITY_GAP_DD = 4;
export const CROSS_PIECE_WOODD_DENSITY_GAP_EP = 13;
export const CROSS_PIECE_WOODD_DENSITY_GAP_ED = 27;
export const CROSS_PIECE_ALU_DENSITY_GAP_DD = 21;
export const CROSS_PIECE_ROD_WEIGHT_SUPPL = 0.01;

export const THICKNESS_CORNER_STEEL = 1.5;
export const THICKNESS_CORNER_INOX = 1.25;
export const DEV_CUT_CORNER = 48;

export const THICKNESS_PANE_DEFAULT = 3;
export const THICKNESS_PANE_MDF_BRUT = 3.4;
export const THICKNESS_PLATE_DEFAULT = 6;
export const THICKNESS_PLATE_MDF_BRUT = 6.8;

export const THICKNESS_WHEELS_BASE_DEFAULT = 18;

//TODO: Ask Kewlox
export const THICKNESS_WHEEL_PANE_BASE_SUPPORT_DEFAULT = 15;

export const THICKNESS_SUPPORT_GLASS = 4;

export const THICKNESS_INTER_SHELF_GLASS = 6;
export const THICKNESS_INTER_SHELF_MDF_AGGLO = 18;

export const THICKNESS_SLAT_WOOD = 22;
export const WIDTH_SLAT_WOOD = 22;
export const THICKNESS_SLAT_ALU = 25;
export const WIDTH_SLAT_ALU = 12;

export const LOCK_TRIANGLE_REFERENCE = 'C4';
export const WHEEL_REFERENCE = 'RO';
export const WHEEL_BRAKE_REFERENCE = 'RORE';
export const FEET_EXTENSIONS_REFERENCE = 'PA-CN';
export const METAL_SUPPORT_IS_REFERENCE = 'FR'; // Only for glass IS (need to help fixing the piece)

export const MIN_WIDTH_NEED_REINFORCE = 1001;

// From 620, EP (F2) cross piece cannot be accepted in front position,
// in goal to avoid reduced depth plate between two EP (F2)
export const MAX_WIDTH_ACCEPT_FRONT_EP = 619;

export const MIN_WIDTH_SIX_WHEEL = 1100;
